import { useState } from 'react';
import { Card, Button, List, Empty } from 'antd';
import { DeleteOutlined, PlusOutlined, FileImageOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import RelatedDrawer from './RelatedDrawer';

interface Props {
  excludeId: string;
  value: string[];
  onChange: (ids: string[]) => void;
}

/** 關聯新聞：下方整排，縮圖 + 完整標題 + 移除；全版 Drawer 挑選。 */
export default function RelatedSection({ excludeId, value, onChange }: Props) {
  const [drawer, setDrawer] = useState(false);
  const related = useQuery({
    queryKey: ['related', value],
    queryFn: () => api.articlesByIds(value),
    enabled: value.length > 0,
  });
  const items = related.data?.items ?? [];

  return (
    <Card
      className="mt-4"
      title={`關聯新聞（${value.length}）`}
      extra={
        <Button type="primary" ghost icon={<PlusOutlined />} onClick={() => setDrawer(true)}>
          挑選關聯新聞
        </Button>
      }
    >
      {value.length === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="尚未選擇關聯新聞" />
      ) : (
        <List
          itemLayout="horizontal"
          dataSource={items}
          renderItem={(a) => (
            <List.Item
              actions={[
                <Button
                  key="x"
                  type="text"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => onChange(value.filter((x) => x !== a.id))}
                />,
              ]}
            >
              <List.Item.Meta
                avatar={
                  a.coverUrl ? (
                    <img src={a.coverUrl} alt="" className="h-12 w-20 rounded object-cover" />
                  ) : (
                    <div className="flex h-12 w-20 items-center justify-center rounded bg-gray-100 text-gray-300">
                      <FileImageOutlined />
                    </div>
                  )
                }
                title={a.title}
              />
            </List.Item>
          )}
        />
      )}

      <RelatedDrawer
        open={drawer}
        excludeId={excludeId}
        selectedIds={value}
        onClose={() => setDrawer(false)}
        onConfirm={(ids) => {
          onChange(ids);
          setDrawer(false);
        }}
      />
    </Card>
  );
}
